import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CustomStateButton } from "../../../../Constant";
import { CUSTOM_BUTTONS } from "../../../../Data/Buttons/DefaultStyle";
import CommonRasiedCustomStateButtons from "./CommonRasiedCustomStateButtons";
import { CUSTOM_STATE_DATA } from "../../../../Data/Buttons/EdgeStyle";

const RaisedCustomStateButtons = () => {
  return (
    <Card>
      <CommonCardHeader title={CustomStateButton} span={CUSTOM_BUTTONS} />
      <CardBody className="btn-showcase">
        {CUSTOM_STATE_DATA.map((item, index) => (
          <CommonRasiedCustomStateButtons data={item} key={index} />
        ))}
      </CardBody>
    </Card>
  );
};

export default RaisedCustomStateButtons;
